import { IconButton } from '@mui/material';
import { Icon } from '../../Atoms/Icon';
import { McpAccessProfile } from '../../../store/McpAccess';

interface McpAccessActionsCellProps {
  profile: McpAccessProfile;
  onRotate: (profile: McpAccessProfile) => void;
  onEdit: (profile: McpAccessProfile) => void;
  onRevoke: (profile: McpAccessProfile) => void;
  disabled?: boolean;
  // The current role cannot hold this token's scope. Rotate re-mints at the existing scope and edit can
  // preserve it, so both are blocked; only revoke (which just removes the token) stays available.
  manageDisabled?: boolean;
}

// The Icon atom is a background-image div, so MUI's color-based disabled styling is invisible;
// dim the button explicitly to signal the disabled state.
const disabledSx = { '&.Mui-disabled': { opacity: 0.35 } };

export const McpAccessActionsCell = ({
  profile,
  onRotate,
  onEdit,
  onRevoke,
  disabled = false,
  manageDisabled = false
}: McpAccessActionsCellProps) => (
  <>
    <IconButton
      aria-label={`Rotate ${profile.title}`}
      disabled={disabled || manageDisabled}
      sx={disabledSx}
      onClick={() => onRotate(profile)}>
      <Icon type="refresh" />
    </IconButton>
    <IconButton
      aria-label={`Edit ${profile.title}`}
      disabled={disabled || manageDisabled}
      sx={disabledSx}
      onClick={() => onEdit(profile)}>
      <Icon type="edit" />
    </IconButton>
    <IconButton
      aria-label={`Revoke ${profile.title}`}
      disabled={disabled}
      sx={disabledSx}
      onClick={() => onRevoke(profile)}>
      <Icon type="trash" />
    </IconButton>
  </>
);
